import { ChangeDetectorRef, Component, OnInit, Inject, LOCALE_ID } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { OrderService } from 'src/app/service/order.service';
import { MatTableDataSource } from '@angular/material/table';
import { delay } from 'rxjs/operators';
import { AuthService } from 'src/app/shared/services/auth.service';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/shared/services/profile.service';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})



export class OrdersComponent implements OnInit {

  firstFormGroup: UntypedFormGroup;
  secondFormGroup: UntypedFormGroup;
  thirdFormGroup: UntypedFormGroup;
  forthFormGroup: UntypedFormGroup;
  fifthFormGroup: UntypedFormGroup;

  orderStatusInfo
  
  orders: any= [];
  dataSource: any = [];
  columsString = ['ORDER DATE', 'ORDER NUMBER', 'ORDER TOTAL', 'ORDER STATUS', 'DETAILS'];
  columnsToDisplay = ['date', 'orderNumber', 'orderTotal', 'orderStatus', '1'];
  expandedElement: PeriodicElement | null;
  discounts: any = [];

  test = 0
  totalCols = 9
  sCols = 2
  stCols = 6
  cdCols = 6
  odCols = 3

  sRows = 1
  stRows = 2
  cdRows = 5
  odRows = 8
  // expandedElement: = null
  avatar: any = './assets/image/profile.svg'
  user: any; // Used for shipping, will be replaced
  selectedOrder: any;
  constructor(
    private _formBuilder: UntypedFormBuilder, 
    private orderService: OrderService, 
    private router: Router, 
    private profileService: ProfileService,
    @Inject(LOCALE_ID) public locale: string) {
    this.selectedOrder = this.router.getCurrentNavigation().extras.state || null;
  }

  getOrder() {
    this.orderService.getOrders().then((resp) => {
      let orders: any = []
      let ordersDoc = []
      orders = resp
      orders.forEach((order: any) => {
        order.articles = [];
        order.displayDetails = false;
        
        if(order.discount_id != ""){
          let orderDiscountId: number = +order.discount_id 
          order.discount = this.discounts[this.discounts.findIndex(e => e.id === orderDiscountId)]
        }
        this.orderService.getOrderArticles(order.id).then( async (resp) => {
          let articles: any = []
          articles = resp
          await this.orderService.getOrderArticlesAttributes(order.id).then((resp) => {
            let attributes: any = []
            attributes = resp
            articles.forEach(article => {
              article.attributes = [];
              attributes.forEach(attribute => {
                if(article.order_article_id == attribute.order_article_id){
                  article.attributes.push(attribute);
                }
              });
              order.articles.push(article)
            });
          })
          order.totalPrice = parseFloat(order.product_price)* order.articles[0].quantity + parseFloat(order.shipping_price) + parseFloat(order.VAT);
        });
      });
      
      this.orders = orders;
      this.expandedElement = ordersDoc[this.selectedOrder]
    }, err => console.log(err))

  }

  async ngOnInit() {

    this.profileService.getUserProfile().subscribe((response: any) => {
      this.user = {
        firstname: response.payload.data().firstName || '',
        lastname: response.payload.data().lastName || '',
        address: response.payload.data().address || '',
        city: response.payload.data().city || '',
        company: response.payload.data().company || '',
        country: response.payload.data().country || '',
        email: response.payload.data().email || '',
        phone: response.payload.data().phone || '',
        zipcode: response.payload.data().zipcode || '',
      }
    });

    await this.orderService.getDiscounts().then((discounts: any)=> {
      this.discounts = discounts
    })

    this.getOrder()
    
    this.orderStatusInfo = [
      { status: 'Processing', btnLabel: 'Add information', color: '#D7D4CB' },
      { status: 'Confirmed', btnLabel: 'Under production', color: '#F6F6F6' },
      { status: 'Shipped', btnLabel: 'Delivery Confirmation', color: '#EADBD8' },
      { status: 'Deliverred', btnLabel: 'Write a review', color: '#B6C1B1' },
    ]

  }

}

export interface PeriodicElement {
  id: number;
  date: string;
  orderNumber: number;
  orderTotal: number;
  orderStatus: number;
}


